export default {
	name: "dialogformConsulta",
	components: {

	},
	data() {
		return {
			fileInput: [],
			token: "",
			blMostrarformConsulta: true,
			blMostrarTexto: true,
			loader: false,
			loaderStatus: 0,
			arrayDuplicadas: [],
			showResult: false,
			valid: true,
			aproved: false,
			sigilosoAbout: false,
			email1: "",
			email2: "",
			strArea: [{
					id: "1",
					strDescricao: "1",
					strNome: "1"
				},
				{
					id: "2",
					strDescricao: "2",
					strNome: "2"
				}
			],
			strTema: [{
				id: " ",
				strDescricao: " "
			}],
			strNome: "",
			strAcao: "",
			blEfeito: false,
			area: null,
			tema: {
				id: '',
				strDescricao: ''
			},
			currentConsulta: {
				campo_nome: '',
				campo_email: '',
				campo_email2: '',
				campo_telefone: '',
				campo_cidade: '',
				campo_uf: '',
				campo_tema: '',
				campo_assunto: '',
				campo_duvida: '',
				campo_uf_duvida: '',
				botao: 'Enviar',
				acao: 'inserir_consulta',
				campo_teste: 0,
				campo_area: '',
				usuario_id: '',
				sigilosa: 0,
				intQtdAnexos: 0,
				blExpress: false,
				blVerificarDuplicidade: true
			},

			file: [],
			fileRules: {
				counter: files => files.length <= 3 || 'Limite ultrapassado',
				size: files => {
					var totalSize = 0

					if (files) {
						files.forEach(file => {
							totalSize = totalSize + file.size
						});
					}

					return !files || totalSize < 25000000 || 'O arquivo deve possuir até 25MB'
				},
			},
			ex: {
				required: value => !!value || 'Campo Obrigatório.',
				counter: value => value.length <= 60 || 'Máximo de 60 caracteres',
				nome: value => {
					const pattern = /([\w\W]{2,}\s[\w\W]{2,})/
					return pattern.test(value) || 'Deve conter nome e sobrenome'
				},
			},
			fileError: {
				status: false,
				messages: []
			},
			tempFile: [],
			editIdentidade: true,
			mensagemErro: '',
			submitted: false,
			message: "",
			helpTema: false,
			estados: [{
					name: "AC",
					value: "Acre"
				},
				{
					name: "AL",
					value: "Alagoas"
				},
				{
					name: "AP",
					value: "Amapá"
				},
				{
					name: "AM",
					value: "Amazonas"
				},
				{
					name: "BA",
					value: "Bahia"
				},
				{
					name: "CE",
					value: "Ceará"
				},
				{
					name: "DF",
					value: "Distrito Federal"
				},
				{
					name: "ES",
					value: "Espírito Santo"
				},
				{
					name: "GO",
					value: "Goiás"
				},
				{
					name: "MA",
					value: "Maranhão"
				},
				{
					name: "MT",
					value: "Mato Grosso"
				},
				{
					name: "MS",
					value: "Mato Grosso do Sul"
				},
				{
					name: "MG",
					value: "Minas Gerais"
				},
				{
					name: "PA",
					value: "Pará"
				},
				{
					name: "PB",
					value: "Paraíba"
				},
				{
					name: "PR",
					value: "Paraná"
				},
				{
					name: "PE",
					value: "Pernambuco"
				},
				{
					name: "PI",
					value: "Piauí"
				},
				{
					name: "RJ",
					value: "Rio de Janeiro"
				},
				{
					name: "RN",
					value: "Rio Grande do Norte"
				},
				{
					name: "RS",
					value: "Rio Grande do Sul"
				},
				{
					name: "RO",
					value: "Rondônia"
				},
				{
					name: "RR",
					value: "Roraima"
				},
				{
					name: "SC",
					value: "Santa Catarina"
				},
				{
					name: "SP",
					value: "São Paulo"
				},
				{
					name: "SE",
					value: "Sergipe"
				},
				{
					name: "TO",
					value: "Tocantins"
				}
			],
			nomeRules: {
				required: value => !!value || 'Campo Obrigatório.',
				counter: value => value ? value.length : 0 <= 60 || 'Máximo de 60 caracteres',
				nome: value => {
					const pattern = /([\w\W]{2,}\s[\w\W]{2,})/
					return pattern.test(value) || 'Deve conter nome e sobrenome'
				},
			},
			emailRules: {
				required: value => !!value || 'Campo Obrigatório.',
				counter: value => value ? value.length : 0 <= 100 || 'Máximo de 100 caracteres',
				email: value => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return pattern.test(value) || 'Email inválido'
				},
			},
			telefoneRules: {
				required: value => !!value || 'Campo Obrigatório.',
				counter: value => value.length <= 11 || 'Máximo de 11 caracteres',
				telefone: value => {
					const pattern = /([0-9]{2}\s?[0-9]{8,9})|(\(?[0-9]{2}\)?\s?[0-9]?\s?[0-9]{4}-?\s?[0-9]{4})/

					return pattern.test(value) || 'Telefone inválido'
				},
			},
			configExpress: {},
			blExibeOpcaoExpress: false,
			salvandoConsulta: false,
		};
	},
	watch: {
		abrir: function() {
			let intOpcao = this.$props.abrir.intOpcao;
			let strAcao = this.$props.abrir.strAcao;
			this.newRegistro();
			//this.$refs.form.reset()

		},
		areaId: function(newA, oldA) {
			if (newA !== null && newA !== oldA) {
				this.currentConsulta.campo_area = newA
				this.tema = {
					id: '',
					strDescricao: ''
				}
				this.$root.$api.listarTemasPorIdArea(this.$root.$store.state.token, this.currentConsulta.campo_area).then(response => {
					this.strTema = response
				})
				this.currentConsulta.campo_uf_duvida = ''

			}
			this.setblExibeOpcaoExpress()
		},
		temaId: function(newA, oldA) {
			if (newA !== null && newA !== oldA) {
				this.currentConsulta.campo_tema = newA

			}
			this.setblExibeOpcaoExpress()
		}
	},
	created() {
		this.getConfigExpress()
	},
	mounted() {
		//this.getDadosSolicitante()
	},
	computed: {
		emails() {
			return this.$root.$store.state.dadosSolicitante.emails
		},
		demonstrativo() {
			return localStorage.getItem("demonstrativo") ? true : false
		},
		blInterno() {
			return localStorage.getItem('blInterno') ? true : false
		},
		areaId() {
			if (this.area) {
				return this.area.id
			} else {
				return ''
			}

		},
		temaId() {
			if (this.tema) {
				return this.tema.id
			} else {
				return ''
			}

		},

		calcFileTotal() {
			var total = 0
			this.file.forEach(file => {
				total = total + file.size
			});

			return total
		},

		getAbrir: {
			get() {
				return this.$root.$store.state.abrirNovaConsulta

			},
			set(value) {
				this.fechar()
			}
		},

		mostra_campo_uf_duvida() {

			const area = Number.parseInt(this.area?.id ?? 0);
			const tema = Number.parseInt(this.tema?.id ?? 0);

			return (
				area  == 3
				|| (
					area == 6
					&& [40, 45].includes(tema)
				)
			);
		}
	},
	methods: {

		getAreas() {
			this.$root.$api.listarAreas(this.token).then(response => {
				this.strArea = response
			})
		},

		newRegistro() {
			//this.$refs.inputNome.reset();
			this.blMostrarformConsulta = true;
			this.submitted = false;
			this.currentConsulta = {};
			setTimeout(() => {
				this.$refs.form.reset()
			}, 0);
			//setTimeout(() => {this.$refs.inputNome.focus();}, 0);
		},

		salvarEmails() {
			this.email1 = this.$root.$store.state.dadosSolicitante.emails[0]; // Email principal
			this.email2 = this.$root.$store.state.dadosSolicitante.emails[1] || ''; // Email secundário, se existir
			// Se precisar salvar os e-mails no Vuex:
			this.$store.commit('setEmails', {
				email1: this.email1,
				email2: this.email2
			});
		},
		resetEmail2() {
			this.email2 = "";  // Isso garante que o email2 seja vazio ao focar no campo
		  },
		  

		fechar() {
			this.valid = true;
			this.salvandoConsulta = false; // Reset do estado do botão
			this.$root.$store.state.abrirNovaConsulta = false
			this.showResult = false;
			// this.editIdentidade = false;
			this.file = []
			//this.$refs.form.reset()
			/**
			 * 
			 */
			this.currentConsulta.campo_uf_duvida = ''
			this.blVerificarDuplicidade = true
			this.$refs.file_upload.reset()
			this.$refs.inputArea.reset()
			this.$refs.inputTema.reset()
			this.$refs.inputAssunto.reset()
			this.$refs.inputDuvida.reset()

			this.currentConsulta.sigilosa = 0
		},
		updateCurrent(titulo, valor) {

		},
		checkRegistro() {
			this.$refs.form.validate()
			this.blMostrarTexto = this.currentConsulta.campo_duvida && this.currentConsulta.campo_duvida.length > 240 ? false : true
			if (this.$refs.form.validate() === true) {
				this.showResult = true
			}
		},
		updateFile(file) {

			var totalSize = this.calcFileTotal

			if (file) {


				file.forEach((itemFile, index) => {
					/**
					 * Checa se já existe um arquivo com mesmo nome
					 * 
					 */

					totalSize = totalSize + itemFile.size
					/* 	if(index){
						
						} */

					if (this.file.length >= 3) {
						this.fileError.status = 3
						return
					}

					if (totalSize >= 25000000) {
						this.fileError.status = 1
						return
					}
					if (this.file.some(item => item.name === itemFile.name)) {
						this.fileError.status = 2
						this.fileError.messages.push(itemFile.name)
						return
					}
					if (itemFile.size >= 25000000) {
						console.log('O arquivo é maior que 25mb')
						return
					} else {
						this.fileError.status = 0
						this.fileError.messages = []

						this.file.push(itemFile)
					}
				});
			}
			this.tempFile = []
			this.currentConsulta.intQtdAnexos = file !== null & file !== undefined ? this.file.length : 0
		},
		cleanFile(index) {
			this.file.splice(index, 1)
			this.$refs.file_upload.reset()
		},
		checkSave() {
			if (this.salvandoConsulta) return; // Evita múltiplos cliques
			
			if (this.$refs.form.validate()) {
				this.salvandoConsulta = true;
				this.saveRegistro()
			} else {
				return
			}
		},
		saveRegistro() {
			var statusSigiloso = this.currentConsulta.sigilosa ? 1 : 0

			// var email2 = "";
			// if(localStorage.getItem("email2")) {
			// 	email2 = localStorage.getItem("email2");
			// }
			if (!this.email1) {
				this.email1 = this.$root.$store.state.dadosSolicitante.emails[0]; // Garantir que email1 tenha valor
			}
			

			var objForm = {
				campo_nome: this.$root.$store.state.dadosSolicitante.nome,
				campo_email: this.email1,//this.$root.$store.state.dadosSolicitante.emails[0],
				campo_email2: this.email2,//this.$root.$store.state.dadosSolicitante.emails[1],
				campo_telefone: this.currentConsulta.campo_telefone,
				campo_cidade: this.$root.$store.state.dadosSolicitante.cidade,
				campo_uf: this.$root.$store.state.dadosSolicitante.uf,
				campo_uf_duvida: this.currentConsulta.campo_uf_duvida,
				campo_tema: this.currentConsulta.campo_tema,
				campo_assunto: this.currentConsulta.campo_assunto,
				campo_duvida: this.currentConsulta.campo_duvida,
				botao: "Enviar",
				acao: "inserir_consulta",
				campo_teste: 0,
				campo_area: this.currentConsulta.campo_area,
				usuario_id: this.$root.$store.state.idUsuario,
				sigilosa: statusSigiloso,
				intQtdAnexos: this.currentConsulta.intQtdAnexos,
				token: this.$root.$store.state.token,
				blExpress: this.currentConsulta.blExpress
			};

			var form = new FormData();

			form.append("campo_nome", objForm.campo_nome);
			form.append("campo_email", objForm.campo_email);
			form.append("campo_email2", objForm.campo_email2);
			form.append("campo_telefone", objForm.campo_telefone);
			form.append("campo_cidade", objForm.campo_cidade);
			form.append("campo_uf", objForm.campo_uf);
			form.append("campo_tema", objForm.campo_tema);
			form.append("campo_assunto", objForm.campo_assunto);
			form.append("campo_duvida", objForm.campo_duvida);
			form.append("botao", "Enviar");
			form.append("acao", "inserir_consulta");
			form.append("campo_teste", localStorage.getItem("demonstrativo") ? 1 : 0);
			form.append("campo_area", objForm.campo_area);
			form.append("usuario_id", objForm.usuario_id);
			form.append("sigilosa", objForm.sigilosa);
			form.append("intQtdAnexos", objForm.intQtdAnexos);
			form.append("token", objForm.token);

			if(objForm.blExpress) {
				form.append("blExpress", 1);
			}else {
				form.append("blExpress", 0);
			}
			
			form.append("blVerificarDuplicidade", this.blVerificarDuplicidade)

			/**
			 * Em caso da existência de arquivos
			 * Faremos um forEach para gerar a chave o valor do formulário de acordo com o padrão da API 
			 * File1, ''
			 * File2, ''
			 * 
			 */

			if (objForm.campo_area == 3 && objForm.campo_tema != 10 && objForm.campo_tema != 33) {
				form.append("campo_uf_duvida", objForm.campo_uf_duvida);
			}
			if (objForm.campo_area == 3 && objForm.campo_tema == 33) {

				form.append("campo_uf_duvida", 'SP');
			}

			if (this.file) {
				this.file.forEach((file, index) => {
					var name = "file" + (index + 1)
					//	console.log(name, file)
					form.append(name, file)
				});
			}

			/* 
			 * Valida se os dados estão todos preenchidos
			 */

			this.loader = true
			this.loaderStatus = 0
			console.log(objForm);
			this.$root.$api.novaConsulta(objForm.token, form).then(response => {

				if (response.data && response.data.resultado) {
					this.loaderStatus = 1
					this.fechar()
					this.$root.$store.state.paginaAtual = '1'
					setTimeout(() => {
						this.loader = false;

						setTimeout(() => {
							this.loaderStatus = 0
							this.$root.$store.state.pesquisaPalavra = ''
							this.$root.$store.state.idAreaLista = ''
							this.$root.$store.state.idTema = ''
							this.$root.$store.state.refreshList = Date.now()

						}, 3000);
					}, 1);
				} else {
					//console.log(response.data)
					this.ativarLoaderErro(response.data.MensagemErro, response.data)
				}
			}).catch(error => {
				console.log('Erro: ', error)
				this.salvandoConsulta = false; // Reabilita o botão em caso de erro
				this.blVerificarDuplicidade = true
				this.ativarLoaderErro(error)
			})
		},
		salvarMesmoAssim() {
			this.blVerificarDuplicidade = false;
			this.loader = false;
			this.loaderStatus = 0;
			this.saveRegistro()
		},
		ativarLoaderErro(MensagemErro, data) {
			this.mensagemErro = MensagemErro

			if(data.blDuplicidade = true){
				this.loaderStatus = 3
				this.arrayDuplicadas = data.consultas
			} else {
				this.loaderStatus = 2
			}
		},
		checkTema() {
			if (this.$root.$store.state.idAreaLista === '') {
				this.helpTema = true

				setTimeout(() => {
					this.helpTema = false
				}, 10000);
			} else {
				return
			}
		},
		goToConsulta(duplicada){
			this.fechar();
			this.loader = false;
			//console.log()
			//this.loaderStatus = 0;
			if(this.$router.history.current.params.id !== duplicada.id && this.$router.history.current.path !== `/listar-consulta/${duplicada.id}`){
				
				if(this.$router.history.current.path !== '/'){
					this.$router.push({path: `../`})
				}

				this.$router.push({path: `/listar-consulta/${duplicada.id}?ano=${duplicada.dtAnoCadastro}`})
			}
		},

		setblExibeOpcaoExpress() {
			let blExibe = false
			
			let idArea = Number(this.currentConsulta.campo_area)
			let idTema = Number(this.currentConsulta.campo_tema)
			let uf     = this.currentConsulta.campo_uf_duvida

			if (idArea > 0) {
				let configsArea = this.configExpress.filter(c => {
					return Number(c.idArea) == idArea
				})

				if (configsArea.length > 0) {

					configsArea.forEach((config, index) => {
						if (config.jsonIdTema != '') {
							let obTemas = JSON.parse(config.jsonIdTema)

							let temasValidos = obTemas.filter(t => {
								return Number(t) == idTema
							})

							if (temasValidos.length > 0) {
								if (config.jsonSiglaUF != null) {
									let obUF = JSON.parse(config.jsonSiglaUF)

									let ufsValidas = obUF.filter(u => {
										return u == uf || (idTema == 33 && u == 'SP')
									})

									if (
										ufsValidas.length > 0 
										|| (idArea == 3 && idTema == 10) // IPI
									) {
										blExibe = true
									}

								} else {
									blExibe = true
								}
							}
						}
					});
				}
			}

			this.currentConsulta.blExpress = false
			this.blExibeOpcaoExpress = blExibe
		},

		getConfigExpress() {
			this.$nextTick(() => {
				let that = this;

				setTimeout(function() {
					let form = new FormData();
					form.append('token', that.$root.$store.state.token);

					that.$root.$api.ListarConfigExpress(form).then(response => {
						that.configExpress = response;
					});
				}, 1000);
			});
		},
	}
};
